export default function DecimalInput(props) {
    function onChange(event) {
        let decimalValue = event.target.value.trim().replace(/[^0-9,.-]/g, '')
        if (decimalValue.length) {
            event.target.value = decimalValue
        } else {
            event.target.value = '';
        }

        if (props.onChange) {
            props.onChange(event);
        }
    }

    return <input type={'text'} {...props} onChange={onChange}/>;
}
